import * as util from "../../util/api";
export function isModInCollection(collection, mod) {
    if (collection.rules === undefined) {
        return false;
    }
    return (collection.rules.find((rule) => util.testModReference(mod, rule.reference)) !== undefined);
}
export function isValidMod(mod) {
    return mod !== undefined && mod.type !== "collection";
}
export function genCollectionLoadOrder(loadOrder, mods, collection) {
    const sortedMods = Object.keys(loadOrder)
        .filter((id) => {
        return collection !== undefined
            ? isValidMod(mods[id]) && isModInCollection(collection, mods[id])
            : isValidMod(mods[id]);
    })
        .sort((lhs, rhs) => loadOrder[lhs].pos - loadOrder[rhs].pos)
        .reduce((accum, iter, idx) => {
        accum[iter] = {
            ...loadOrder[iter],
            pos: idx,
        };
        return accum;
    }, {});
    return sortedMods;
}
